// Simple Matcha Theme JS

// Cart drawer
const cartOverlay = document.querySelector('.cart-overlay');
const cartDrawer = document.querySelector('.cart-drawer');
const cartClose = document.querySelector('.cart-close');
const cartBtns = document.querySelectorAll('[data-open-cart]');

function openCart() {
  cartOverlay && cartOverlay.classList.add('open');
  cartDrawer && cartDrawer.classList.add('open');
}
function closeCart() {
  cartOverlay && cartOverlay.classList.remove('open');
  cartDrawer && cartDrawer.classList.remove('open');
}
cartBtns.forEach(btn => btn.addEventListener('click', openCart));
cartClose && cartClose.addEventListener('click', closeCart);
cartOverlay && cartOverlay.addEventListener('click', closeCart);

// Quantity selector
document.querySelectorAll('.qty-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const input = btn.closest('.qty-selector').querySelector('.qty-input');
    let val = parseInt(input.value) || 1;
    if (btn.dataset.action === 'plus') val = Math.min(val + 1, 99);
    if (btn.dataset.action === 'minus') val = Math.max(val - 1, 1);
    input.value = val;
  });
});

// Variant buttons
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('.variant-options').querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  });
});

// Product image gallery
document.querySelectorAll('.product-thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const src = thumb.dataset.src;
    const main = document.querySelector('.product-main-img img');
    if (main && src) main.src = src;
    document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// Quiz
document.querySelectorAll('.quiz-option').forEach(opt => {
  opt.addEventListener('click', () => {
    opt.closest('.quiz-options').querySelectorAll('.quiz-option').forEach(o => o.classList.remove('selected'));
    opt.classList.add('selected');
  });
});

// Mobile menu toggle
const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
const mobileNav = document.querySelector('.mobile-nav');
mobileMenuBtn && mobileMenuBtn.addEventListener('click', () => {
  mobileNav && mobileNav.classList.toggle('open');
});

// Add to cart AJAX
const addToCartForm = document.querySelector('[data-product-form]');
addToCartForm && addToCartForm.addEventListener('submit', async (e) => {
  e.preventDefault();
  const formData = new FormData(addToCartForm);
  const btn = addToCartForm.querySelector('.add-to-cart');
  btn.textContent = 'Adding...';
  try {
    const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
    if (res.ok) {
      btn.textContent = 'Added!';
      openCart();
      await updateCart();
    }
  } catch (err) { console.error(err); }
  setTimeout(() => { btn.textContent = 'Add to Cart'; }, 2000);
});

// Buy Now: add to cart, then go straight to checkout
const buyNowBtn = document.querySelector('[data-buy-now]');
buyNowBtn && buyNowBtn.addEventListener('click', async () => {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;
  const formData = new FormData(form);
  buyNowBtn.textContent = 'Adding...';
  try {
    const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
    if (res.ok) {
      window.location.href = '/checkout';
      return;
    }
  } catch (err) { console.error(err); }
  buyNowBtn.textContent = 'Buy Now';
});

function formatMoney(cents) {
  return 'RM' + (cents / 100).toFixed(2) + ' MYR';
}

function renderCartDrawer(cart) {
  const countEl = document.querySelector('.cart-count');
  const subtotalEl = document.querySelector('.cart-subtotal strong');
  const itemsEl = document.querySelector('.cart-items');
  if (countEl) countEl.textContent = cart.item_count;
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  document.querySelectorAll('.cart-count').forEach(el => { el.textContent = cart.item_count; });
  if (typeof smRenderFreeShipping === 'function') smRenderFreeShipping(cart);
  if (typeof smRenderStickyCount === 'function') smRenderStickyCount(cart);
  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p></div>';
    return;
  }

  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cart-item">
      <div class="cart-item-img">
        ${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}
      </div>
      <div class="cart-item-details">
        <p class="cart-item-name">${item.product_title}</p>
        <p class="cart-item-variant">${item.variant_title || ''}</p>
        <div class="cart-qty" role="group" aria-label="Quantity">
          <button type="button" class="cart-qty__btn" data-cart-qty data-key="${item.key}" data-to="${item.quantity - 1}" aria-label="Decrease quantity">&minus;</button>
          <span class="cart-qty__val">${item.quantity}</span>
          <button type="button" class="cart-qty__btn" data-cart-qty data-key="${item.key}" data-to="${item.quantity + 1}" aria-label="Increase quantity">+</button>
        </div>
        <p class="cart-item-price">${formatMoney(item.final_price)}</p>
      </div>
      <a href="/cart/change?id=${item.key}&quantity=0" class="cart-item-remove" data-cart-remove data-key="${item.key}" aria-label="Remove ${item.product_title}">&#x2715;</a>
    </div>
  `).join('');
}

async function updateCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCartDrawer(cart);
  } catch(e) {}
}

// Remove item from cart — works for both server-rendered and JS-rendered items
document.addEventListener('click', async (e) => {
  const removeBtn = e.target.closest('[data-cart-remove]');
  if (!removeBtn) return;
  e.preventDefault();
  const key = removeBtn.dataset.key;
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    if (res.ok) {
      const cart = await res.json();
      renderCartDrawer(cart);
    }
  } catch (err) { console.error(err); }
});

// Cart drawer quantity +/- buttons
document.addEventListener('click', async (e) => {
  const qtyBtn = e.target.closest('[data-cart-qty]');
  if (!qtyBtn || qtyBtn.hasAttribute('data-busy')) return;
  e.preventDefault();
  const key = qtyBtn.dataset.key;
  const to = Math.max(0, parseInt(qtyBtn.dataset.to, 10) || 0);
  const row = qtyBtn.closest('.cart-item');
  if (row) row.style.opacity = '0.5';
  qtyBtn.setAttribute('data-busy', '1');
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: to })
    });
    if (res.ok) {
      const cart = await res.json();
      renderCartDrawer(cart);
    } else if (row) {
      row.style.opacity = '1';
    }
  } catch (err) {
    console.error(err);
    if (row) row.style.opacity = '1';
  }
  qtyBtn.removeAttribute('data-busy');
});

/* ============================================================
   SM CONVERSION — promo bar, countdown, free-ship progress,
   quick-add, product variant sync, sticky add-to-cart
   ============================================================ */
(function () {
  'use strict';

  function money(cents) { return 'RM' + (Math.round(cents) / 100).toFixed(2); }
  window.smMoney = money;

  /* ---------- Countdown timers ----------
     data-countdown-to     : ISO end time (required)
     data-countdown-start  : ISO start time (optional). Before it, counts down to the start.
     data-countdown-startlabel / data-countdown-endlabel : prefix words ("Starts in" / "Ends in")
     data-countdown-done   : "hide" removes the wrapper when the end passes; else shows the done label
     data-countdown-donelabel : text shown after the end when not hiding
  */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function fmt(ms) {
    var d = Math.floor(ms / 86400000);
    var h = Math.floor((ms % 86400000) / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    return (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  /* Times typed without a timezone are read as Malaysia time (+08:00) for EVERY visitor,
     so a promo starts/ends at the same real moment no matter where the browser is. */
  function parseTime(str) {
    if (!str) return NaN;
    str = String(str).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) str += 'T00:00:00';
    if (!/(Z|[+-]\d{2}:?\d{2})$/i.test(str)) str += '+08:00';
    return new Date(str).getTime();
  }
  window.smParseTime = parseTime;

  /* Promo ended → put the normal announcement message back (no manual switch-off needed) */
  function revertPromoBar(wrap) {
    if (!wrap) return;
    var std = wrap.getAttribute('data-standard-text');
    if (!std) { wrap.style.display = 'none'; return; }
    wrap.classList.remove('promo-bar--sale');
    var msg = wrap.querySelector('.promo-bar__msg');
    if (msg) msg.textContent = std;
    wrap.querySelectorAll('.promo-bar__code, .promo-bar__count, .promo-bar__link').forEach(function (n) { n.style.display = 'none'; });
  }

  function tickCountdowns() {
    document.querySelectorAll('[data-countdown-to]').forEach(function (el) {
      var end = parseTime(el.getAttribute('data-countdown-to'));
      var start = parseTime(el.getAttribute('data-countdown-start'));
      var hasEnd = !isNaN(end), hasStart = !isNaN(start);
      if (!hasEnd && !hasStart) return;
      var now = Date.now();
      var wrap = el.closest('[data-countdown-wrap]') || el;

      if (hasStart && now < start) {
        var pre = el.getAttribute('data-countdown-startlabel');
        el.textContent = (pre ? pre + ' ' : '') + fmt(start - now);
        return;
      }
      if (!hasEnd) {  /* live with no end time → no timer */
        el.style.display = 'none';
        var pt = el.parentNode;
        if (pt && pt.classList && pt.classList.contains('promobanner__timer')) pt.style.display = 'none';
        return;
      }
      if (now >= end) {
        var done = el.getAttribute('data-countdown-done');
        if (done === 'revert') { revertPromoBar(wrap); }
        else if (done === 'hide' && wrap) { wrap.style.display = 'none'; }
        else { el.textContent = el.getAttribute('data-countdown-donelabel') || 'Ended'; }
        return;
      }
      var pre2 = el.getAttribute('data-countdown-endlabel');
      el.textContent = (pre2 ? pre2 + ' ' : '') + fmt(end - now);
    });
  }
  if (document.querySelector('[data-countdown-to]')) { tickCountdowns(); setInterval(tickCountdowns, 1000); }

  /* ---------- Promo phase text ----------
     An element with [data-phase] swaps its text (and can hide) based on a sale window:
     data-phase-start / data-phase-end : ISO times
     data-phase-before / data-phase-during / data-phase-after : text for each window
     data-phase-hide-before / data-phase-hide-after : "1" to hide the element in that window
     Runs once on load and again at each boundary. Server renders the "before" text as a safe default.
  */
  function applyPhases() {
    document.querySelectorAll('[data-phase]').forEach(function (el) {
      var start = parseTime(el.getAttribute('data-phase-start'));
      var end = parseTime(el.getAttribute('data-phase-end'));
      var now = Date.now();
      var win = 'during';
      if (!isNaN(start) && now < start) win = 'before';
      else if (!isNaN(end) && now >= end) win = 'after';
      var txt = el.getAttribute('data-phase-' + win);
      var hide = el.getAttribute('data-phase-hide-' + win) === '1';
      var shouldHide = hide || (txt === '' && win !== 'during');
      /* Inline style, not el.hidden — some elements have an author CSS rule
         (e.g. display:inline-block) that outranks the browser's default
         [hidden]{display:none}, so el.hidden alone can silently fail to hide. */
      el.style.display = shouldHide ? 'none' : '';
      if (!shouldHide && txt !== null && txt !== '') el.textContent = txt;
    });
  }
  if (document.querySelector('[data-phase]')) {
    applyPhases();
    setInterval(applyPhases, 30000);
  }

  /* ---------- Dismissible promo bar ---------- */
  document.querySelectorAll('[data-promo-dismiss]').forEach(function (btn) {
    var bar = btn.closest('[data-promo-bar]');
    var key = 'sm_promo_dismissed_' + (bar ? bar.getAttribute('data-promo-id') || '0' : '0');
    try { if (localStorage.getItem(key) === '1' && bar) bar.style.display = 'none'; } catch (e) {}
    btn.addEventListener('click', function () {
      if (bar) bar.style.display = 'none';
      try { localStorage.setItem(key, '1'); } catch (e) {}
    });
  });

  /* ---------- Free-shipping progress ---------- */
  window.smRenderFreeShipping = function (cart) {
    var bars = document.querySelectorAll('[data-free-shipping-bar]');
    if (!bars.length) return;
    bars.forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      var total = cart ? cart.total_price : 0;
      var remaining = threshold - total;
      var fillEl = bar.querySelector('[data-fs-fill]');
      var msgEl = bar.querySelector('[data-fs-msg]');

      /* Promo window: free shipping on every order (no minimum) between start and end */
      var promoStart = parseTime(bar.getAttribute('data-promo-start'));
      var promoEnd = parseTime(bar.getAttribute('data-promo-end'));
      var nowMs = Date.now();
      if (!isNaN(promoStart) && nowMs >= promoStart && (isNaN(promoEnd) || nowMs < promoEnd)) {
        if (fillEl) fillEl.style.width = '100%';
        if (msgEl) msgEl.innerHTML = bar.getAttribute('data-msg-promo') || 'Free shipping on every order right now';
        bar.setAttribute('data-unlocked', 'true');
        return;
      }
      var pct = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 0;
      if (fillEl) fillEl.style.width = pct + '%';
      if (msgEl) {
        if (remaining <= 0) {
          msgEl.innerHTML = bar.getAttribute('data-msg-success') || "You've unlocked free shipping";
          bar.setAttribute('data-unlocked', 'true');
        } else {
          var tmpl = bar.getAttribute('data-msg-progress') || "You're {amount} away from free shipping";
          msgEl.innerHTML = tmpl.replace('{amount}', '<strong>' + money(remaining) + '</strong>');
          bar.setAttribute('data-unlocked', 'false');
        }
      }
    });
  };

  /* ---------- Sticky bar cart count ---------- */
  window.smRenderStickyCount = function (cart) {
    document.querySelectorAll('[data-sticky-count]').forEach(function (el) {
      el.textContent = cart ? cart.item_count : 0;
    });
  };

  /* ---------- Quick-add (buy grid / collection cards) ---------- */
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.hasAttribute('data-adding')) return;
    var original = btn.innerHTML;
    btn.setAttribute('data-adding', '1');
    btn.innerHTML = 'Adding…';
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      });
      if (res.ok) {
        btn.innerHTML = 'Added ✓';
        if (typeof openCart === 'function') openCart();
        if (typeof updateCart === 'function') await updateCart();
      } else {
        btn.innerHTML = 'Sold out';
      }
    } catch (err) { btn.innerHTML = 'Try again'; }
    setTimeout(function () { btn.innerHTML = original; btn.removeAttribute('data-adding'); }, 1800);
  });

  /* ---------- Product page: variant sync + sticky add-to-cart ---------- */
  var pForm = document.querySelector('[data-product-form]');
  var vDataEl = document.getElementById('sm-variant-data');
  if (pForm && vDataEl) {
    var variants = [];
    try { variants = JSON.parse(vDataEl.textContent); } catch (e) {}
    var idInput = pForm.querySelector('input[name="id"]');
    var priceEl = document.getElementById('sm-price');
    var atcBtn = pForm.querySelector('.add-to-cart');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyAtc = document.querySelector('[data-sticky-atc-btn]');

    function currentSelections() {
      var sel = [];
      pForm.querySelectorAll('.variant-options').forEach(function (group) {
        var active = group.querySelector('.variant-btn.active');
        if (active) sel.push(active.getAttribute('data-value'));
      });
      return sel;
    }
    function matchVariant(sel) {
      return variants.find(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      });
    }
    function renderPrice(v) {
      if (!v) return;
      var html = '';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<s>' + money(v.compare_at_price) + '</s> ';
      }
      html += money(v.price);
      if (priceEl) priceEl.innerHTML = html;
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      var soldOut = !v.available;
      if (atcBtn) { atcBtn.textContent = soldOut ? 'Sold Out' : 'Add to Cart'; atcBtn.disabled = soldOut; }
      if (stickyAtc) { stickyAtc.textContent = soldOut ? 'Sold Out' : 'Add to Cart'; stickyAtc.disabled = soldOut; }
    }
    function updateVariant() {
      var v = matchVariant(currentSelections());
      if (v && idInput) { idInput.value = v.id; renderPrice(v); }
    }
    pForm.querySelectorAll('.variant-btn').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(updateVariant, 0); });
    });

    var stickyBar = document.querySelector('[data-sticky-atc]');
    if (stickyBar && atcBtn) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          stickyBar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(atcBtn);
      if (stickyAtc) stickyAtc.addEventListener('click', function () {
        if (typeof pForm.requestSubmit === 'function') pForm.requestSubmit();
        else pForm.querySelector('.add-to-cart').click();
      });
    }
  }

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('[data-faq-q]').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('[data-faq-item]');
      if (item) item.classList.toggle('open');
    });
  });

  /* ---------- Restock notify form (sold-out bundle CTA) ---------- */
  document.addEventListener('submit', async function (e) {
    var form = e.target.closest('[data-restock-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var originalLabel = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    try {
      await fetch(form.action, { method: 'POST', body: new FormData(form) });
    } catch (err) { /* Shopify's /contact endpoint has no CORS issues same-origin; ignore network noise */ }
    form.querySelectorAll('input, button').forEach(function (el) { el.style.display = 'none'; });
    var success = form.querySelector('.bundlecta__notify-success');
    if (success) success.hidden = false;
    if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
  });

  /* ---------- Initial cart fetch for free-ship bar / sticky count ---------- */
  if (document.querySelector('[data-free-shipping-bar]') || document.querySelector('[data-sticky-count]')) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      smRenderFreeShipping(cart);
      smRenderStickyCount(cart);
    }).catch(function () {});
  }
})();
